const ShortSentMailTableConfig = [
  {
    field: 'mailType',
    label: 'Typ wiadomości',
    sort: 'asc',
    type: 'enum',
    enumType: 'enums/mailType',
    width: 150,
  },
  {
    field: 'status',
    label: 'Status',
    sort: 'asc',
    type: 'enum',
    enumType: 'enums/mailStatus',
    width: 150,
  }
];

export default ShortSentMailTableConfig;